<div class="modal-wrapper">
  <div class="modal-content">
    <!-- Close Button -->
    <ion-button fill="clear" class="close-button" (click)="dismiss()">
      <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>

    <!-- Header Section -->
    <div class="header-section">
      <div class="support-icon">
        <img src="assets/images/support.png" alt="Support" />
      </div>
      <div class="header-text-container">
        <ion-label class="fs-4 font700 primary-text-color"
          >Support & Assistance</ion-label
        >
        <p class="fs-2 font500 modal-secondary-text-color header-desc">
          For questions regarding your refund or cancellation, reach us 24/7
        </p>
      </div>
    </div>

    <!-- Contact Information -->
    <div>
      <div class="contact-item">
        <span class="fs-2 font600">
          <b>Email Support:</b><span class="marl4 support-text">{{ support.emailSupport }}</span>
          <ion-icon
            (click)="copyToClipboard(support.emailSupport)"
            name="copy-outline"
            class="vertical-middle-icon"
          ></ion-icon
        ></span>
      </div>
      <div class="contact-item">
        <span class="fs-2 font600"
          ><b>WhatsApp Support:</b><span class="marl4 support-text"> +{{ support.chatSupport }}</span>
          <ion-icon
            (click)="copyToClipboard(support.chatSupport)"
            name="copy-outline"
            class="vertical-middle-icon"
          ></ion-icon
        ></span>
      </div>
    </div>

    <!-- Request Call Button -->
    <!-- <ion-button expand="block" class="primary-btn mart10" (click)="requestCall()">
      Request Call
    </ion-button> -->
  </div>
</div>
